import axiosApi from "./ajaxToAxios"

export const vacanciesFormApi = (data) => {
  return axiosApi.post({
    url: `/api/vakancies/anketa`,
    data: JSON.stringify(data),
    contentType : "application/json",
  })
}

export const vacanciesCvApi = (data) => {
  return axiosApi.post({
    url: `/api/vakancies/resume`,
    data: JSON.stringify(data),
    contentType : "application/json",
  })
}